import { useEffect, useState } from "react";
import "./ExcluirModal.css";

export default function ExcluirModal({ open, titulo, onClose, onConfirmar }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function handleOk() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
      onClose?.();
    } catch (e) {
      setErr(e?.message || "Falha ao excluir");
    } finally {
      setBusy(false);
    }
  }

  useEffect(() => {
    if (!open) return;

    setBusy(false);
    setErr("");

    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKey = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        onClose?.();
      }
      if (e.key === "Enter") {
        e.preventDefault();
        handleOk();
      }
    };

    document.addEventListener("keydown", onKey, true);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener("keydown", onKey, true);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="exmd-bg">
      <div className="exmd-box" role="dialog" aria-modal="true" aria-label="Excluir ativo">
        <header className="exmd-head">
          <h3 className="exmd-title">Excluir</h3>
          <button className="exmd-x" onClick={onClose} type="button" aria-label="Fechar" title="Fechar" disabled={busy}>
            x
          </button>
        </header>

        <div className="exmd-body">
          Tem certeza que deseja <strong>excluir</strong> "{titulo || "este registro"}"?
          <div className="exmd-warn">Esta acao nao pode ser desfeita.</div>
          {err ? <div className="exmd-err">{err}</div> : null}
        </div>

        <footer className="exmd-foot">
          <button className="exmd-btn" type="button" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="exmd-btn exmd-btn-danger" type="button" onClick={handleOk} disabled={busy}>
            {busy ? "Excluindo..." : "Excluir"}
          </button>
        </footer>
      </div>
    </div>
  );
}
